import React from 'react';
import { Shield, AlertCircle, FileText } from 'lucide-react';
export function ComplianceSection() {
  return <section id="compliance" className="py-16 bg-white" data-id="element-30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-31">
        <div className="text-center mb-12" data-id="element-32">
          <h2 className="text-3xl font-bold text-gray-900" data-id="element-33">
            Regulatory Compliance
          </h2>
          <p className="mt-4 text-lg text-gray-600 max-w-3xl mx-auto" data-id="element-34">
            We adhere to all regulatory requirements set by SEBI and other
            governing bodies to ensure transparent and secure financial
            services.
          </p>
        </div>
        <div className="bg-blue-50 border border-blue-100 rounded-lg p-8 mb-8" data-id="element-35">
          <div className="flex items-start" data-id="element-36">
            <AlertCircle className="h-6 w-6 text-blue-800 mr-3 flex-shrink-0 mt-1" data-id="element-37" />
            <div data-id="element-38">
              <h3 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-39">
                Risk Disclosure
              </h3>
              <p className="text-gray-600" data-id="element-40">
                Investments in securities market are subject to market risks;
                read all the related documents carefully before investing. The
                securities quoted are for illustration only and are not
                recommendatory.
              </p>
            </div>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-41">
          <div className="bg-gray-50 p-6 rounded-lg shadow-sm" data-id="element-42">
            <Shield className="h-8 w-8 text-blue-600 mb-4" data-id="element-43" />
            <h3 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-44">
              SEBI Registration
            </h3>
            <p className="text-gray-600 mb-4" data-id="element-45">
              Max Cap Securities operates as an authorized sub-broker of
              TradeJini under SEBI Registration No: INZ000038535.
            </p>
            <a href="#" className="text-blue-800 hover:underline flex items-center" data-id="element-46">
              <FileText className="h-4 w-4 mr-1" data-id="element-47" />
              View Certificate
            </a>
          </div>
          <div className="bg-gray-50 p-6 rounded-lg shadow-sm" data-id="element-48">
            <Shield className="h-8 w-8 text-blue-600 mb-4" data-id="element-49" />
            <h3 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-50">
              Exchange Memberships
            </h3>
            <p className="text-gray-600 mb-4" data-id="element-51">
              Through our association with TradeJini, we provide access to NSE,
              BSE, and MCX trading platforms in compliance with exchange
              regulations.
            </p>
            <a href="#" className="text-blue-800 hover:underline flex items-center" data-id="element-52">
              <FileText className="h-4 w-4 mr-1" data-id="element-53" />
              Exchange Guidelines
            </a>
          </div>
          <div className="bg-gray-50 p-6 rounded-lg shadow-sm" data-id="element-54">
            <Shield className="h-8 w-8 text-blue-600 mb-4" data-id="element-55" />
            <h3 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-56">
              Investor Protection
            </h3>
            <p className="text-gray-600 mb-4" data-id="element-57">
              We prioritize investor protection through transparent practices,
              secure systems, and adherence to regulatory guidelines.
            </p>
            <a href="#" className="text-blue-800 hover:underline flex items-center" data-id="element-58">
              <FileText className="h-4 w-4 mr-1" data-id="element-59" />
              Investor Charter
            </a>
          </div>
        </div>
        <div className="mt-12 p-6 border border-gray-200 rounded-lg" data-id="element-60">
          <h3 className="text-xl font-semibold text-gray-900 mb-4" data-id="element-61">
            Important Links
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-62">
            <a href="https://www.sebi.gov.in" target="_blank" rel="noopener noreferrer" className="text-blue-800 hover:underline" data-id="element-63">
              SEBI Official Website
            </a>
            <a href="https://www.nseindia.com" target="_blank" rel="noopener noreferrer" className="text-blue-800 hover:underline" data-id="element-64">
              National Stock Exchange (NSE)
            </a>
            <a href="https://www.bseindia.com" target="_blank" rel="noopener noreferrer" className="text-blue-800 hover:underline" data-id="element-65">
              Bombay Stock Exchange (BSE)
            </a>
            <a href="https://www.mcxindia.com" target="_blank" rel="noopener noreferrer" className="text-blue-800 hover:underline" data-id="element-66">
              Multi Commodity Exchange (MCX)
            </a>
            <a href="https://scores.gov.in" target="_blank" rel="noopener noreferrer" className="text-blue-800 hover:underline" data-id="element-67">
              SEBI Complaints Redress System
            </a>
            <a href="https://www.tradejini.com" target="_blank" rel="noopener noreferrer" className="text-blue-800 hover:underline" data-id="element-68">
              TradeJini Official Website
            </a>
          </div>
        </div>
      </div>
    </section>;
}